module.exports = __webpack_public_path__ + "static/video_tb_en-a5db350c34042dbc224896b60dee0675.mp4";